import React from 'react';
import { createPortal } from 'react-dom';
import { t } from '../i18n';

const Modal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        padding: '20px'
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#1f2937',
          color: '#ffffff',
          padding: '30px',
          borderRadius: '12px',
          maxWidth: '500px',
          width: '100%',
          border: '2px solid #ef4444',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
          textAlign: 'center'
        }}
      >
        {title && (
          <h2 style={{
            margin: '0 0 20px 0',
            fontSize: '24px',
            color: '#ef4444',
            fontWeight: 'bold'
          }}>
            {title}
          </h2>
        )}

        <p style={{
          margin: '0 0 30px 0',
          fontSize: '18px',
          lineHeight: '1.6',
          color: '#ffffff'
        }}>
          {message}
        </p>

        <button
          onClick={onClose}
          style={{
            padding: '12px 30px',
            fontSize: '16px',
            fontWeight: 'bold',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#dc2626';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#ef4444';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          {t('Закрыть')}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Modal;